/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Devedor } from '../models/devedor';
import { ScoreSerasa } from '../models/score-serasa';
@Injectable({
  providedIn: 'root',
})
class DevedoresService extends __BaseService {
  static readonly atualizarDevedorPath = '/devedores';
  static readonly obterScoreSerasaPath = '/devedores/score/{cpfCnpj}/{codigoRamo}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Atualiza os dados de um devedor
   * @param request Objeto com os dados do devedor a ser atualizado
   */
  atualizarDevedorResponse(request: Devedor): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/devedores`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Atualiza os dados de um devedor
   * @param request Objeto com os dados do devedor a ser atualizado
   */
  atualizarDevedor(request: Devedor): __Observable<null> {
    return this.atualizarDevedorResponse(request).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Recupera o score e o Indice de inadimplecia
   * @param params The `DevedoresService.ObterScoreSerasaParams` containing the following parameters:
   *
   * - `cpfCnpj`: Cpf ou Cnpj Do Devedor
   *
   * - `codigoRamo`: Codigo do Ramo
   *
   * @return Operacao realizada com sucesso
   */
  obterScoreSerasaResponse(params: DevedoresService.ObterScoreSerasaParams): __Observable<__StrictHttpResponse<ScoreSerasa>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/devedores/score/${encodeURIComponent(String(params.cpfCnpj))}/${encodeURIComponent(String(params.codigoRamo))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ScoreSerasa>;
      })
    );
  }
  /**
   * Recupera o score e o Indice de inadimplecia
   * @param params The `DevedoresService.ObterScoreSerasaParams` containing the following parameters:
   *
   * - `cpfCnpj`: Cpf ou Cnpj Do Devedor
   *
   * - `codigoRamo`: Codigo do Ramo
   *
   * @return Operacao realizada com sucesso
   */
  obterScoreSerasa(params: DevedoresService.ObterScoreSerasaParams): __Observable<ScoreSerasa> {
    return this.obterScoreSerasaResponse(params).pipe(
      __map(_r => _r.body as ScoreSerasa)
    );
  }
}

module DevedoresService {

  /**
   * Parameters for obterScoreSerasa
   */
  export interface ObterScoreSerasaParams {

    /**
     * Cpf ou Cnpj Do Devedor
     */
    cpfCnpj: string;

    /**
     * Codigo do Ramo
     */
    codigoRamo: number;
  }
}

export { DevedoresService }
